import { externalUrls } from "@/constants/url";
import { useSuspenseQuery } from "@tanstack/react-query";

export function usePeaks(isrc: string) {
  const { data } = useSuspenseQuery<{ peaks: number[]; duration: number }>({
    queryKey: ["peaks", isrc],
    queryFn: () => fetch(`${externalUrls.MUSIC_RESOURCE_BASE_URL}/${isrc}.json`).then((res) => res.json()),
  });

  return data;
}
